import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getProductionProcesses({ commit }, payload = {
        paginate: '',
        query: ''
    }) {
        const paginate = payload.paginate,
            query = payload.query

        return axios
            .get(`/production-processes/processes${paginate}${query}`)
            .then(response => {
                commit('GET_PRODUCTION_PROCESSES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie listy procesów produkcyjnych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProductionProcess(context, productionProcessId) {
        return axios
            .get(`/production-processes/processes/${productionProcessId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych do procesu produkcyjnego ${productionProcessId} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    createProductionProcess({ commit }, productionProcessData) {
        return axios
            .post('/production-processes/processes', productionProcessData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Proces produkcyjny został dodany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie procesu produkcyjnego nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateProductionProcess({ commit }, productionProcessData) {
        return axios
            .put(`/production-processes/processes/${productionProcessData.id}`, productionProcessData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Proces produkcyjny został zedytowany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja procesu produkcyjnego nie powiodła się.')

                return Promise.reject(error)
            })
    },
    getSteps() {
        return axios
            .get('/production-processes/dicts/steps')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie kodów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setProductProductionProcessesFilters({ commit }, filters) {
        commit('SET_PRODUCT_PRODUCTION_PROCESSES_FILTERS', filters)
    },
    clearProductProductionProcessesFilters({ commit }) {
        commit('CLEAR_PRODUCT_PRODUCTION_PROCESSES_FILTERS')
    }
}